export default "__VITE_ASSET__Cehjvh8U__$_?component__"